import { useTranslation } from 'react-i18next';
import { makeRoutes } from '../constants';

export const useRoutes = () => {
  const { i18n } = useTranslation('translation');
  return makeRoutes(i18n.language);
};

export default useRoutes;
